import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { HttpResponse } from "@/types";

export function useGetPlacementCount() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["placementCount", currentCompanyId],
    queryFn: async () => {
      const path = `companies/placementCount?companyId=${currentCompanyId}`;
      const res = await httpClient.get<number, HttpResponse<number>>(path);
      return res.data;
    },
  });
}
